<!--
Author: TangChen
Date: 2018-09-10
Desc: 登录页面，实现手机，证件号登录，由router.js 配置引入
 -->
<template>
    <div class="view-login view">
        <header-com :tit="'用户登录'" />
        <div class="login-main">
            <div class="container">
                <div class="login-panel" :style="{ top: login_top + 'px' }">
                    <el-tabs v-model="loginUser">
                        <el-tab-pane label="个人客户" name="enduser">
                            <div class="login-cert-type">
                                <el-radio-group v-model="loginCertType" v-on:change="resetForm('loginForm')">
                                    <el-radio v-for="item in loginType" :key="item.id" :label="item.id">
                                        {{ item.name }}
                                    </el-radio>
                                </el-radio-group>
                            </div>
                            <div class="login-form">
                                <el-form ref="loginForm" :rules="rules" :model="loginForm" label-width="0" v-on:keyup.enter.native="login">
                                    <el-form-item v-if="loginCertType === '1'" label="" prop="phone">
                                        <el-input v-model="loginForm.phone" :maxlength="11" placeholder="请输入手机号码" prefix-icon="fa fa-mobile" />
                                    </el-form-item>
                                    <el-form-item v-if="loginCertType === '2'" label="" prop="certType" class="icon-select">
                                        <i class="fa fa-id-card select-card" />
                                        <el-select v-model="loginForm.certType" placeholder="请选择证件类型" v-on:change="checkCertNoAgain">
                                            <el-option v-for="item in certTypes" :key="item.subitem" :label="item.subitemname" :value="item.subitem" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-if="loginCertType === '2'" label="" prop="certNo">
                                        <el-input v-model="loginForm.certNo" :maxlength="20" placeholder="请输入证件号码" prefix-icon="fa fa-id-card" />
                                    </el-form-item>
                                    <el-form-item label="" prop="password">
                                        <el-input
                                            v-model="loginForm.password"
                                            type="password"
                                            class="reset-pwd"
                                            :maxlength="32"
                                            placeholder="请输入密码"
                                            prefix-icon="fa fa-lock"
                                            v-on:keydown.native="detectCapsLock"
                                        >
                                            <span slot="append" type="text" class="reset-btn" v-on:click.once="forgetPwd">忘记密码</span>
                                        </el-input>
                                        <div class="capsLock-tip js-capsLock" :class="{ hide: !capsLock }">
                                            <i class="capsLockTip-triangle" />
                                            大写锁定已打开
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="" prop="verifyCode">
                                        <el-input v-model="loginForm.verifyCode" placeholder="请输入验证码" :maxlength="4" prefix-icon="fa fa-shield">
                                            <span slot="append" class="prop-verify"><img id="verifyImg" :src="imgSrc" v-on:click="refresh"></span>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <div class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                                            <div style="display: flex; align-items: flex-start;">
                                                <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                                                <span style="padding-left:5px;line-height:30px;">
                                                    本人已经仔细阅读并同意
                                                    <span style="color:red;cursor: pointer;" v-on:click="protocol = true">《隐私政策》</span>
                                                    相关内容，同意遵照前述法律文件约定执行
                                                </span>
                                            </div>
                                        </div>
                                    </el-form-item>
                                    <el-form-item class="login-btn">
                                        <el-button type="primary" class="login-n" v-on:click="login">
                                            立即登录
                                        </el-button>
                                        <el-button v-if="!($cache.getParams().function_mask&&($cache.getParams().function_mask.indexOf('1')>-1))" class="quick" v-on:click="register">
                                            快速注册
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <!--暂时平屏蔽-->
                            <div class="login-other border-top">
                                <div v-if="others && others.length > 0" class="login-other-box">
                                    <div v-for="list in others" :key="list.id" class="other-list cursor" v-on:click="loginFromWX(list)">
                                        <!--<img class="other-list-img" :src="require('../../assets/img/' + list.url + '.png')">
                                        <span class="other-list-text">{{ list.val }}</span>-->
                                    </div>
                                </div>
                                <div class="login-btn-msg right">
                                    <el-tooltip class="item" effect="info">
                                        <div slot="content">
                                            <p>其他渠道购买并持有{{ $cache.getCompanyInfo().companyname||"" }}基金的用户，可以登录并查询资产持有状况。</p>
                                            <p>初始登录密码为开户证件号码后6位数字，号码不足6位的前面加0补足，身份证最后一位是字母X的改为0。</p>
                                        </div>
                                        <!--<el-button type="text" class="d-login">-->
                                        <!--代销客户登录-->
                                        <!--<i class="fa fa-question-circle" />-->
                                        <!--</el-button>-->
                                    </el-tooltip>
                                </div>
                            </div>
                        </el-tab-pane>
                        <!--暂时平屏蔽-->
                        <el-tab-pane v-if="false" label="机构客户" name="org">
                            {{ loginUser }}
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <el-carousel id="carousel" :interval="5000" :height="ad_height + 'px'">
                <el-carousel-item v-for="item in ads" :key="item.imgid">
                    <div class="login-ad">
                        <a v-if="item.linkurl" :href="item.linkurl" :target="item.opentype === '2' ? '_blank' : '_self'">
                            <img :src="item.imgid" :style="{ height: ad_height + 'px', width: ad_width + 'px' }">
                        </a>

                        <img v-if="!item.linkurl" :src="item.imgid" :style="{ height: ad_height + 'px', width: ad_width + 'px' }">
                    </div>
                </el-carousel-item>
            </el-carousel>
            <log />
        </div>
        <footer-com style="visibility: hidden;" />
        <footer-com style="bottom:0px;position:absolute;width:100%;" />
        <agreement v-model="protocol" agrCon="agreement_privacyPolicy" title="隐私政策" v-on:all-read="protocol=false"></agreement>
    </div>
</template>

<script>
import headerCom from "@/components/layout/header.vue";
import footerCom from "@/components/layout/footer.vue";
import log from "@/components/misc/log.vue";
import agreement from "@/components/form/agreement2.vue";
import agreement1 from "@/components/form/agreement.vue";
export default {
    components: {
        headerCom,
        footerCom,
        log,
        agreement,
        agreement1
    },
    data() {
        return {
            imgRefresh: null,
            ad_ratio: 3, // 轮播广告图片的长宽比
            ad_width: 0,
            ad_height: 0, // 轮播广告图片高度，由setPageSize方法计算后赋值
            login_top: "10",
            ads: [],
            loginType: [{ id: "1", name: "手机号登录" }, { id: "2", name: "证件号登录" }],
            /* { id: "1", val: "QQ账号", url: "qq_icon" }, */
            others: [{ id: "2", val: "微信登录", url: "wx_icon",name: "wxbind" }],
            certTypes: [], // 证件类型
            loginForm: {
                phone: "",
                password: "",
                verifyCode: "",
                certType: "0",
                certNo: ""
            },
            imgSrc: "",
            loginUser: "enduser",
            loginCertType: "1",
            capsLock: false,
            checkbox: false,// 是否同意隐私政策
            rules: {
                phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }, { validator: this.$util.validateMobile, trigger: "blur" }],
                certType: [{ required: true, message: "请选择证件类型", trigger: "change" }],
                certNo: [{ required: true, message: "请输入证件号码", trigger: "change" }, { validator: this.checkCertNo, trigger: "change" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                verifyCode: [{ validator: this.$util.validateImgVerifyCode, trigger: "blur" }]
            },
            /* wx跳转 */
            wxLoginParam: {},
            protocol:false
        };
    },
    created() {
        sessionStorage.setItem("alreadyread","");
        this.getImgInfo();
        this.refresh();
        this.$cache.initCityCountyList();
    },
    mounted() {
        document.body.onresize = (function(o) {
            return function() {
                o.setPageSize();
            };
        })(this);
        this.certTypes = this.$cache.getDict("130007").concat([{
            dictitem: "130007",
            subitem: "00",
            subitemname: "基金账号",
            sysid: "4"
        },{
            dictitem: "130007",
            subitem: "99",
            subitemname: "股东账号",
            sysid: "4"
        }]).filter(val=> val.subitemname === "身份证");
        if (this.$cache.getParams().function_mask && (this.$cache.getParams().function_mask.indexOf("0") > -1)) {
            this.loginType = this.loginType.filter(item => {
                return item.id != "1";
            });
            this.loginCertType = "2";
        }
        this.setPageSize();
        // 前端心跳-每隔3分钟刷新验证码图片，以达到登录页面用不超时的效果
        this.imgRefresh = setInterval(
            (function(o) {
                return function() {
                    o.refresh();
                };
            })(this),
            3 * 60 * 1000
        );
        this.getUrlParam();
        this.checkEncWay();

    },
    beforeDestroy() {
        clearInterval(this.imgRefresh);
    },
    methods: {
        /* 处理banner宽度和高度 */
        setPageSize() {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w = w < 1200 ? 1200 : w;
            this.ad_width = w;
            this.ad_height = w / this.ad_ratio;
            if (this.ad_height < 500) {
                this.ad_height = 500;
                this.ad_width = this.ad_height * this.ad_ratio;
            }
            // 登录表单位置计算
            this.login_top = (this.ad_height - 470) / 2;
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            this.$util.validateCertNo(rule, value, callback, this.loginForm.certType);
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.loginForm.validateField("certNo");
        },
        // 判断是否开启大写输入
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        /* 刷新验证码图片 */
        refresh() {
            this.imgSrc = this.$util.imgUrl();
        },
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            this.$router.push({ name: "resetpwdway", query: { tit: "找回密码" } });
        },
        /* 表单重置 */
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // 解决表单切换
            this[formName].phone = "";
            this[formName].certNo = "";
        },
        /* 表单登录 */
        login() {
            if(!this.checkbox){
                return this.$alert("根据相关法规要求，请在登录前仔细阅读并同意相关文件。","提示", {confirmButtonText: "确定"});
            }
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.formValidSuccess();
                    return false;
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 快捷注册 */
        register() {
            if (this.loginUser === "enduser") {
                this.$router.push({ name: "register", query: { tit: "快速开户" } });
            }
        },
        getImgInfo() {
            const x = this.$cache.getAdvertiseInfo("1");
            for (let i in x) {
                x[i].imgid = this.$util.src("/common/download", { id: x[i].fileid });
            }
            this.ads = x;
        },
        /* 登录成功 */
        formValidSuccess() {
            const _this = this;
            const loginPwd = this.$util.enc(this.loginForm.password);
            let t = this.loginForm.certType;
            let a = "0";
            if (this.loginCertType === "1") {
                t = "";
                a = "8";
            }else{
                a = "0";
                if (t === "00") {
                    a = "2";
                }
                if (t === "99") {
                    a = "g";
                    t = "00";
                }
            }
            const _data = {
                accttype: a,
                certificatetype: t,
                certificateno: this.loginForm.certNo,
                mobile: this.loginForm.phone,
                investortype: "1",
                verifycode: this.loginForm.verifyCode,
                loginpwd: loginPwd
            };
            this.$req({ url: "/common/login", data: _data, method: "POST" })
                .then(res => {
                    // 登录状态和数据更新
                    if (res.code === "0000000") {
                        _this.$store.dispatch("login", res.record[0][0]).then(() => {
                            _this.$router.push("/home");
                        });
                    } else {
                        _this.refresh();
                        _this.$message({
                            type: "warning",
                            message: res.msg
                        });
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        },
        loginFromWX (list) {
            //this.$router.push({name: list.name});
            if (this.loginUser === "enduser") {
                let backurl = encodeURIComponent(window.location.href);
                let appid = this.$cache.getCompanyInfo().wechat_web_appid || "";
                window.location.href = "https://open.weixin.qq.com/connect/qrconnect?appid=" + this.$cache.getCompanyInfo().wechat_web_appid + "&redirect_uri=" + backurl + "&response_type=code&scope=snsapi_login&state=" + this.$cache.getSessionToken() + "#wechat_redirect";
            }
        },
        //获取URL查询参数
        getUrlParam () {
            var queryStr = location.href;
            var targetUrl = queryStr.substr(queryStr.indexOf("?") + 1).split("&");
            targetUrl.forEach(f => {
                this.$set(this.wxLoginParam, f.split("=")[0], f.split("=")[1]);
            });
            if (this.wxLoginParam.code) this.wxlogin();
        },
        //wx是否绑定，是否直接微信登录
        wxlogin () {
            const _this = this;
            this.$req({ url: "/oauth/wechat", data: this.wxLoginParam, method: "POST" })
                .then(res => {
                    // 绑定状态
                    if (res.code === "0000000") {
                        if(res.record[0][0].bound === "0") {
                            _this.$router.push({name: "wxbind"});
                        } else {
                            _this.$store.dispatch("login", {"key": res.record[0][0].aeskey, "token": res.record[0][0].token}).then(() => {
                                _this.$router.push("/home");
                            });
                        }
                    } else {
                        _this.refresh();
                        _this.$message({
                            type: "warning",
                            message: res.msg
                        });
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        },
        /* 查看柜台是否开启国密 */
        checkEncWay () {
            this.$util.getGtParamsValue ("1001164",res => {
                if(res.paramvalue.indexOf("A90") > -1) {
                    sessionStorage.setItem("isOpenGMEnc", "1");
                }else {
                    sessionStorage.setItem("isOpenGMEnc", "0");
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.view-login {
	.login-main {
		background: $bg9;
		.el-carousel {
			width: 100%;
			overflow: hidden;
			min-width: 1200px;
		}
		.container {
			position: relative;
			.login-panel {
				box-shadow: 0 0 5px $border-color2;
				.el-tabs__content {
					background-color: #f9f9f9;
				}
				width: 360px;
				position: absolute;
				right: 0;
				top: 100px;
				z-index: 999;
				background: $bg2;
				padding: 10px 0 0;
				border-radius: 6px 6px;
				overflow: hidden;
				.el-tabs__header.is-top {
					margin: 0;
				}
				.el-tabs__nav-wrap.is-scrollable {
					padding: 0;
				}
				.el-tabs__active-bar {
					width: 180px !important;
					background: $bg18;
				}
				.el-tabs__item {
					width: 180px;
					padding: 0;
					font-size: 16px;
					color: $text-color3;
					text-align: center;
					&.is-active {
						color: $color-a;
					}
				}
				.login-cert-type {
					padding: 11px 0;
					background: $bg1;
					.el-radio {
						display: inline-block;
						width: 156px;
						margin-right: 0;
						text-align: left;
						padding-left: 24px;
						.el-radio__label {
							line-height: 24px;
							font-size: 16px;
						}
						.el-radio__input.is-checked + .el-radio__label {
							color: $text-color2;
						}
					}
					.el-radio + .el-radio {
						margin: 0;
					}
				}
				.login-other {
					padding: 15px 10px 15px 13px;
					.login-other-box {
						display: inline-block;
						.other-list {
                            cursor: pointer;
							margin-right: 20px;
							display: inline-block;
							.other-list-img {
								vertical-align: middle;
								width: 23px;
								height: 23px;
								display: inline-block;
							}
							.other-list-text {
								color: $text-color3;
								margin-left: 5px;
                                vertical-align: middle;
							}
						}
					}
					.login-btn-msg {
						display: inline-block;
						vertical-align: middle;
						color: $text-color1;
						.d-login {
							color: $color-b;
							float: right;
                            padding: 0;
                            span{line-height: 23px;display: inline-block;}
						}
					}
				}
				.login-form {
					background: $bg2;
					padding: 10px 15px 0;
					.el-form-item {
						&.icon-select {
							position: relative;
						}
						&.login-btn {
							padding: 5px 0 21px 0;
							text-align: center;
							margin-bottom: 0;
							.login-n {
								float: left;
								font-size: $f16;
								min-width: 150px;
							}
							.quick {
								color: $color-a;
								font-size: $f16;
								float: right;
								min-width: 150px;
							}
						}
						.fa.fa-id-card.select-card {
							position: absolute;
							z-index: 1000;
							font-size: $f20;
							color: #c0c4cc;
							top: 11px;
							left: 6px;
						}
						margin-bottom: 16px;
						.el-select {
							width: 330px;
							.el-input__inner {
								padding-left: 40px;
							}
						}
						.el-input {
							border-bottom: 1px solid $border-color5;
							.el-input__inner {
								border: none;
								border-radius: 0;
								padding-left: 40px;
							}
							.el-input__icon {
								font-size: $f20;
								// color:
							}
						}
						.el-form-item__error {
							padding: 0;
							width: 100%;
							text-indent: 40px;
							//background: $bg6;
							font-size: $f14;
							color: $color-c;
							padding: 4px 0;
							z-index: 2;
							font-family: 'element-icons' !important;
							font-style: normal;
							font-weight: normal;
							font-variant: normal;
							text-transform: none;
							line-height: 1;
							vertical-align: baseline;
							display: inline-block;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
						}
						.el-col.el-col-19 {
							.el-form-item--small.el-form-item {
								margin-bottom: 0px;
							}
						}
						.reset-pwd .el-input-group__append {
							width: 38px;
						}
						.el-input-group__append {
							color: $color-a;
							border: none;
							background: none;
							padding: 0;
							cursor: pointer;
							.reset-btn {
								padding: 0;
							}
							.prop-verify {
								height: 38px;
								float: right;
							}
						}
					}
				}
			}
		}
	}
}
</style>
